export enum CommentStatus {
  NEW = 0,
  REJECTED = 1,
  COMPLETE = 2,
}
